var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSevenSendersPortalLogoWhite = function SvgSevenSendersPortalLogoWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "alexmalex18562438423642940234823",
    d: "M0 28.814h21.126L9.46 48.99C3.84 44.028.23 36.846 0 28.814zm17.118-8.794H1.14C4.577 8.445 15.289 0 27.98 0a27.865 27.865 0 0 1 16.54 5.412H28.11c-4.535 0-11.28 3.116-11.28 11.702 0 1.05.102 2.016.288 2.906zm35.219-5.814A27.839 27.839 0 0 1 55.979 28c0 15.463-12.536 27.999-28 27.999-3.942 0-7.69-.818-11.092-2.287l14.396-24.898 7.952-.001c2.542.113 2.542 2.07 2.542 2.908 0 .837 0 2.794-2.542 2.908h-9.98l-2.207 3.819h12.227c.256-.002 6.305-.102 6.305-6.727s-6.049-6.725-6.306-6.727l-10.195.002-15.59 26.966c-.332-.2-.655-.41-.976-.624l15.231-26.344H.142c.041-.388.09-.773.147-1.157h23.817c-1.77-1.036-3.458-2.999-3.458-6.724 0-7.794 7.387-7.884 7.461-7.884h20.645c.34.376.667.763.987 1.157H28.109c-.256.001-6.304.102-6.304 6.727 0 6.258 5.352 6.695 6.2 6.724h1.745l-.002.002 9.527-.002c.075 0 7.462.09 7.462 7.884 0 7.793-7.387 7.883-7.462 7.883H26.379l-2.208 3.819h15.12c4.534 0 11.28-3.116 11.28-11.702S43.825 20.02 39.29 20.02H28.087c-.11-.01-.782-.092-1.357-.398-.387-.205-1.106-.586-1.106-2.508 0-.838 0-2.795 2.54-2.908h24.173z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "alexmalexsdflsjdfskdjfius",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#alexmalex18562438423642940234823"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#2D3233",
    xlinkHref: "#alexmalex18562438423642940234823"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#alexmalexsdflsjdfskdjfius)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h56v56H0z"
  })))));
};
export default SvgSevenSendersPortalLogoWhite;